import { Route, Routes, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import Album from './pages/Album';
import ArtistProfile from './pages/ArtistProfile';
import Genres from './pages/Genres';
import SearchResults from './pages/SearchResults';
import Genre from './pages/Genre';
import Search from './pages/Search';
import Single from './pages/Single';
import { useEffect, useState } from 'react';
import ScrollToTop from './components/ScrollToTop';

function App() {
  
  const location = useLocation();
  const [hideNavbar, setHideNavbar] = useState(false);

  useEffect(() => {
    const path = location.pathname;

    if (path.startsWith("/single/") || path.startsWith("/album/")) {
      setHideNavbar(true);
    } else {
      setHideNavbar(false);
    }
  }, [location.pathname]);

  return (
    <div className='bg-deep-night'>
      <ScrollToTop />
      {!hideNavbar && <Navbar />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/single/:singleId" element={<Single />} />
        <Route path="/album/:albumId" element={<Album />} />
        <Route path="/artist/:artistId" element={<ArtistProfile />} />
        <Route path="/genres" element={<Genres />} />
        <Route path="/genre/:genreName" element={<Genre />} />
        <Route path="/search" element={<Search />} />
        <Route path="/search/:value" element={<SearchResults />} />
      </Routes>
    </div>
  );
}

export default App;